var _a;
import { IdAssetBundleInitialStatic } from "./IdAssetBundleInitialStatic";
export var assetBundleInitialStatic = (_a = {},
    _a[IdAssetBundleInitialStatic.FarmBackground_Default] = require("../../assets/background/background_default_compressed.jpg"),
    _a[IdAssetBundleInitialStatic.FarmHorizon_Default] = require("../../assets/background/horizon_default_compressed.jpg"),
    _a[IdAssetBundleInitialStatic.Cursor_Pointer] = require("../../assets/cursors/cursor32_pointer.png"),
    _a);



//////////////////
// WEBPACK FOOTER
// ./src/assetBundles/static/assetBundleInitialStatic.ts
// module id = 802
// module chunks = 3